module.exports = __webpack_public_path__ + "static/media/sandstorm.91646514.png";